<template>
  <div>
    <div class="table-header">
      <h3>返品商品</h3>
    </div>
    <BaseTableList
        class="received-table"
        :table-set-list="setList"
        :display-items="filteredItems" />
  </div>
</template>

<style scoped>
.received-table >>> tr > th:not(:nth-last-child(2)),
.received-table >>> tr > td:not(:last-child) {
  padding-right: 0;
}
.received-table >>> tr > td {
  color: #396095;
  font-weight: normal;
}
.received-table >>> tr .cell{
  padding-left: 0;
  padding-right: 0;
}
</style>

<script>
import _ from 'lodash'

import x from '@/components/mixins/mixin'
import orderUtil from '@/components/mixins/orderUtil'

import { ELEMENT_TYPE } from '@/components/molecules/BaseCell'
import BaseTableList from '@/components/molecules/BaseTableList'

export default {
  name: 'OrderDetailReceivedItems',
  components: {
    BaseTableList
  },
  mixins: [x, orderUtil],
  inject: ['parentValidator'],
  props: {
    originData: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    filteredItems () {
      return _.chain(this.originData)
        .get('shipments')
        .flatMap(val => val.items)
        .filter(val => val != null && this.$_orderUtil_unprocessedReceivedQty(val.qty) > 0)
        .value()
    },
    setList () {
      return [
        { label: 'No', path: 'position', type: 'String', width: 70 },
        { label: 'SKU', path: 'productId', type: 'String', width: 200 },
        { label: '商品名', path: 'lineitemText', type: 'String' },
        { label: '売価', path: 'basePrice.gross', type: 'Number', width: 150, class: 'right' },
        {
          label: '数量', path: (row) => {
            return this.$_orderUtil_unprocessedReceivedQty(row.qty)
          }, type: 'Number', elementType: ELEMENT_TYPE.FUNCTION,
          width: 150, class: 'right'
        }
      ]
    }
  },
  created () {
    this.$validator = this.parentValidator
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/order/OrderDetailReceivedItems.vue